import styled from 'styled-components/macro';
import { css } from 'styled-components';

export const PickerTitleCategory = styled.button<{
  selected: boolean;
  selectable?: boolean;
}>`
  padding: 0.25rem 0;
  margin-left: 1rem;
  @media (min-width: 1024px) {
    font-size: 0.95rem;
  }
  @media (min-width: 1280px) {
    font-size: 1rem;
    padding: 0.25rem 0.75rem;
  }
  color: ${p => p.theme.gray600};
  ${p =>
    p.selected &&
    p.selectable &&
    css`
      background-color: ${p => p.theme.main};
      padding: 0 0.5rem;
      border-radius: 0.25rem;
      color: ${p => p.theme.white};
    `};
`;
